import { SuperuserAiSettingsPage } from "@/features/superuser/ai-settings/superuser-ai-settings.page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/superuser/ai-settings")({
  component: SuperuserAiSettingsPage,
});
